// extracted by mini-css-extract-plugin
module.exports = {"container":"spacing_container__m_T0y"};